import { useCallback } from "react";
import { DutTestpoint } from "../models/signalSources/dutTestpoint.ts";
import { apiFile } from "../dependencies/api.ts";
import { useMessageHandler } from "../context/MessageContext.tsx";

export const useCsvToDutTestpoints = () => {
  const { handle } = useMessageHandler();

  const upload = useCallback(async (file: File): Promise<DutTestpoint[] | null> => {
    const formData = new FormData();
    formData.append("file", file);

    return await handle(async () => {
      const response = await apiFile.post("/mechanics/testpoints/from_csv", formData);
      return response.data as DutTestpoint[];
    }).catch((e: Error) => {
      return null;
    });
  }, [handle]);

  return { upload };
};
